import { useEffect, useRef } from "react"

export function useUpdateEffect(effect, deps) {
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    return effect()
  }, deps)
}
